/**
 * LeadLostModal — reason picker shown when a lead is moved to "lost"
 * (select, kanban drop, detail modal). Consequential action ⇒ deliberate step.
 */
import { useEffect, useState } from "react";
import { XCircle } from "@phosphor-icons/react";
import ModalCloseButton from "../ui/ModalCloseButton";
import LoaderLoop from "../shared/loader/LoaderLoop";
import { LEAD_LOST_REASONS } from "../../utils/leadContract";

function LeadLostModal({ lead, isSaving = false, onClose, onConfirm }) {
  const [reason, setReason] = useState("not_relevant");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (lead) {
      setReason(lead.lostReason || "not_relevant");
      setNote("");
    }
  }, [lead]);

  if (!lead) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal ld-modal ld-lost-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="tb-modal-title">
            <span className="tb-modal-icon ld-icon-muted">
              <XCircle size={18} weight="fill" />
            </span>
            <div className="ld-modal-heading">
              <span className="ld-eyebrow">סגירת מתעניין</span>
              <h3>{lead.name}</h3>
            </div>
          </div>
          <ModalCloseButton onClick={onClose} />
        </div>
        <div className="modal-body">
          <p className="ld-muted-text">המתעניין יסומן כ"לא רלוונטי" ויעבור לארכיון. ניתן להחזיר אותו בכל עת על ידי שינוי הסטטוס.</p>
          <div className="ld-reason-grid" role="radiogroup" aria-label="סיבה">
            {LEAD_LOST_REASONS.map((r) => (
              <button
                key={r.value}
                type="button"
                role="radio"
                aria-checked={reason === r.value}
                className={`ld-reason${reason === r.value ? " is-selected" : ""}`}
                onClick={() => setReason(r.value)}
                disabled={isSaving}
              >
                {r.label}
              </button>
            ))}
          </div>
          <div className="form-group">
            <label>הערה (אופציונלי)</label>
            <input type="text" value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} placeholder="למה זה לא התקדם?" disabled={isSaving} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={isSaving}>
            ביטול
          </button>
          <button className="btn-primary" onClick={() => onConfirm({ lostReason: reason, lostNote: note.trim() || null })} disabled={isSaving}>
            {isSaving && <LoaderLoop size="xs" />}
            <span>סגור מתעניין</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeadLostModal;
